import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Location } from "@angular/common";
import Swal from "sweetalert2";

import { InvestorType } from "src/app/shared/enum/investor-type.enum";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { InfoPerfisComponent } from "../info-perfis/info-perfis.component";

@Component({
  selector: "app-selecao-tipo-usuario",
  templateUrl: "./selecao-tipo-usuario.component.html",
  styleUrls: ["./selecao-tipo-usuario.component.scss"],
})
export class SelecaoTipoUsuarioComponent {
  @Output() tipoSelecionado = new EventEmitter<InvestorType>();
  @Input() deveExibirAlertaPF = true;
  @Input () customTitle: boolean = true;

  isInvestidor: boolean = false;

  modalRef: MDBModalRef;

  constructor(
    private modalService: MDBModalService,
    private location: Location
  ) {}

  setType(param: number) {
    switch (param) {
      case 1: {
        this.isInvestidor = true;
        break;
      }
      case 2: {
        this.tipoSelecionado.emit(InvestorType.Entity);
        break;
      }
    }
  }

  setForm(param: number) {
    switch (param) {
      case 1: {
        this.exibirAlertaPF();
        break;
      }
      case 2: {
        this.tipoSelecionado.emit(InvestorType.PJ);
        break;
      }
      case 3: {
        this.tipoSelecionado.emit(InvestorType.Investment);
        break;
      }
    }
  }

  backStep() {
    this.isInvestidor = false;
  }

  voltarInicio() {
    this.location.back();
  }

  private exibirAlertaPF() {
    if (!this.deveExibirAlertaPF) {
      this.tipoSelecionado.emit(InvestorType.PF);
      return;
    }

    const style = document.createElement('style');
    style.innerHTML = `
      .my-popup-swal {
        border-radius: 15px;
        font-family: Raleway;
      }
      .my-title-swal {
        border-bottom: 1px solid #eee;
        padding-bottom: 15px;
        font-size: 24px;
      }
      .my-confirm-swal {
        margin-left: 16px;
        background-color: #3b3b8f;
        color: #F8F8F8;
        padding: 11px 30px;
        border-radius: 8px;
        font-weight: 600;
        border:  solid #3b3b8f;

      }
      .my-cancel-swal {
        background-color: #fff;
        color: #3b3b8f;
        border: 1px solid #3b3b8f;
        padding: 12px 30px;
        border-radius: 8px;
        font-weight: 600;
      }
    `;
    document.head.appendChild(style);

    Swal.fire({
      title: '<span><i class="fas fa-info-circle" style="color: #f39c12;"></i> Atenção</span>',
      html: `
        <div class="swal-custom-body">
          <strong style="display: block; margin-bottom: 20px;">Este é um canal exclusivo para Pessoa Física - Garantia Especial (DPGE).</strong>
          <p>Para solicitar a Garantia Ordinária como Pessoa Física, cadastre-se e acompanhe o processo pelo aplicativo do <b>FGC</b> (disponível em todas as lojas de aplicativo mobile).</p>
        </div>
      `,
      width: "700px",
      padding: "2em",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonText: 'Sim, sou investidor (DPGE)',
      cancelButtonText: '<i class="fas fa-arrow-left"></i> Voltar',
      buttonsStyling: false,
      customClass: {
        popup: 'my-popup-swal',
        title: 'my-title-swal',
        confirmButton: 'my-confirm-swal',
        cancelButton: 'my-cancel-swal'
      }
    }).then((res) => {
      if (res.isConfirmed) {
        this.tipoSelecionado.emit(InvestorType.PF);
      } else if (res.isDismissed || res.isDenied) {
        return;
      }
    });
  }

  openModalInfoPerfis() {
     const config = {
      scroll: true,
      backdrop: true,
      ignoreBackdropClick: false
    };

    this.modalRef = this.modalService.show(
      InfoPerfisComponent,
      config
    );
  }
}
